import { CommonConstant } from '@utility/constants/common';
import type {
  ListingMappingBody,
  MappableListing,
  MappableListingsParams,
  MappingState,
  SourceKind,
} from './types';

/* The source filter's choices: every connection, or one kind of them. */
export const ALL_SOURCES = 'all';
export type SourceFilter = typeof ALL_SOURCES | SourceKind;

export type MappableFilter = {
  page: number;
  limit: number;
  search: string;
  source: SourceFilter;
  /** Also the Inactive / ARCHIVED / UNLISTED unmapped listings (M2). */
  showInactive: boolean;
};

export const initialMappableFilter = (search: string): MappableFilter => ({
  page: 1,
  limit: CommonConstant.defaultPageSize,
  search,
  source: ALL_SOURCES,
  showInactive: false,
});

export function buildMappableParams(
  state: MappingState,
  filter: MappableFilter,
): MappableListingsParams {
  const params: MappableListingsParams = {
    state,
    page: filter.page,
    limit: filter.limit,
    search: filter.search.trim(),
  };

  if (filter.source !== ALL_SOURCES) {
    params.sourceKind = filter.source;
  }

  if (filter.showInactive) {
    params.showInactive = true;
  }

  return params;
}

/** The unmapped reason of a listing a person excluded on purpose. */
export const EXCLUDED_REASON = 'excluded';

/** Map or re-map: an excluded listing needs the API's explicit override. */
export function mapBody(
  listing: Pick<MappableListing, 'unmappedReason'>,
  itemId: string,
): ListingMappingBody {
  return listing.unmappedReason === EXCLUDED_REASON
    ? { itemId, allowExcluded: true }
    : { itemId };
}

export const excludeBody: ListingMappingBody = { exclude: true };
